module.exports = __webpack_public_path__ + "static/orangeConvoBubble-88d10de58d4a99461cbc27288954530a.png";